import { cn } from '#/utils/cn';

export interface TickerProps {
  symbol: string;
  size?: 'xs' | 'sm' | 'md';
  className?: string;
}

const sizeClasses = {
  xs: 'text-static-10',
  sm: 'text-static-12',
  md: 'text-static-14',
};

export function Ticker({ symbol, size = 'md', className }: TickerProps) {
  return (
    <span
      className={cn(
        'bg-slate-10 min-w-ticker inline-block rounded px-2 py-4 text-center',
        sizeClasses[size],
        className,
      )}
    >
      {symbol}
    </span>
  );
}
